import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { RootState } from '../../../../setup';
import { createStyles, withStyles } from '@mui/styles';
import { resetFactorSetWeight, resetFactorSetWeights } from '../../../../reducers/factorSetWeightReducer';
import { FormType } from '../../../../constants/constants';
import AddFactorSetWeightForm from './addFactorSetWeightForm';

interface IAddFactorSetWeightProps {
    classes: any;
    theme: Theme;
    match: any;
    resetFactorSetWeights: () => any;
    resetFactorSetWeight: () => any;
    steps: Array<number>;
    factorSetWeightId?: number;
    factorSetVersionId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetFactorSetWeights: () => dispatch(resetFactorSetWeights()),
    resetFactorSetWeight: () => dispatch(resetFactorSetWeight())
});

const mapStoreToProps = (store: RootState, ownProps: IAddFactorSetWeightProps) => {
    return {
        factorSetWeightId: ownProps.match.params?.weightId ? Number(ownProps.match.params?.weightId) : undefined,
        factorSetVersionId: ownProps.match.params?.factorSetVersionId ? Number(ownProps.match.params?.factorSetVersionId) : undefined
    };
};

class AddFactorSetWeight extends Component<IAddFactorSetWeightProps> {
    componentWillUnmount() {
        const { resetFactorSetWeights, resetFactorSetWeight } = this.props;

        resetFactorSetWeights();
        resetFactorSetWeight();
    }

    render() {
        const { classes, steps, factorSetWeightId, type, factorSetVersionId } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <AddFactorSetWeightForm factorSetWeightId={factorSetWeightId} steps={steps} type={type} factorSetVersionId={factorSetVersionId} />
                </CardContent>
            </Card>
        );
    }
}
  
export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddFactorSetWeight));